import router from '@/router/index'
import i18n from '@/plugins/i18n'
import Vue from 'vue'
import appHelpers from '@/helpers/app.helpers'
import { getPlatformName } from '@/constants/platformNames'
import { BLUE_COLOUR, WHITE_COLOUR } from '@/constants/colours'
import { isMobile } from '@/helpers/ui.helpers'

export default { ...appHelpers,
  openSupportChat () {
    var dimensions = {
      height: isMobile ? window.innerHeight : 700,
      width: isMobile ? window.innerHeight : 400
    }
    window.open('https://widget-page.smartsupp.com/widget/2208bb3618a649a6e2e120bf7daf45d0e18594af', 'supportChat', `resizable,height=${dimensions.height},width=${dimensions.width},screenX=0,screenY=0`)
    return false
  },
  buildFaviconsAndTheme (appName) {
		const mediaLightTheme = '(prefers-color-scheme: light)'
		const mediaDarkTheme = '(prefers-color-scheme: dark)'
		return {
			link: [
				{ rel: 'apple-touch-icon', sizes: '180x180', href: `/static-appopensalud/img/favicons/${appName}/apple-touch-icon.png`, media: mediaLightTheme },
				{ rel: 'icon', type: 'image/png', sizes: '32x32', href: `/static-appopensalud/img/favicons/${appName}/favicon-32x32.png`, media: mediaLightTheme },
				{ rel: 'icon', type: 'image/png', sizes: '16x16', href: `/static-appopensalud/img/favicons/${appName}/favicon-16x16.png`, media: mediaLightTheme },
				{ rel: 'manifest', href: `/static-appopensalud/img/favicons/${appName}/site.webmanifest`, media: mediaLightTheme },
				{ rel: 'mask-icon', href: `/static-appopensalud/img/favicons/${appName}/safari-pinned-tab.svg`, color: WHITE_COLOUR, media: mediaLightTheme },
				{ rel: 'apple-touch-icon', sizes: '180x180', href: `/static-appopensalud/img/favicons/${appName}/dark-theme/apple-touch-icon.png`, media: mediaDarkTheme },
				{ rel: 'icon', type: 'image/png', sizes: '32x32', href: `/static-appopensalud/img/favicons/${appName}/dark-theme/favicon-32x32.png`, media: mediaDarkTheme },
				{ rel: 'icon', type: 'image/png', sizes: '16x16', href: `/static-appopensalud/img/favicons/${appName}/dark-theme/favicon-16x16.png`, media: mediaDarkTheme },
				{ rel: 'manifest', href: `/static-appopensalud/img/favicons/${appName}/dark-theme/site.webmanifest`, media: mediaDarkTheme },
				{ rel: 'mask-icon', href: `/static-appopensalud/img/favicons/${appName}/dark-theme/safari-pinned-tab.svg`, color: BLUE_COLOUR, media: mediaDarkTheme }
			],
			meta: [
				{ name: 'msapplication-TileImage', content: BLUE_COLOUR },
				{ name: 'theme-color', content: BLUE_COLOUR }
			]
		}
	},
  getMetaTitleText (route) {
    if (route.meta && route.meta.title && route.meta.title.text) {
      if (route.meta.title.text instanceof Function) {
        return route.meta.title.text()
      } else {
        return i18n.t(route.meta.title.text)
      }
    }
  },
  buildMetaInfo ({ appName, appTagLine = 'Opensalud' }) {
    const $route = router.history.current
    appTagLine = !appTagLine ? '' : ` | ${$route.meta.tagLine || getPlatformName()}`
    return {
      title: `${(($route.meta && $route.meta.title && ($route.meta.title.htmlTitle || $route.meta.title.text)) ? (`${$route.meta.title.htmlTitle || this.getMetaTitleText($route)}`) : '')}${appTagLine}`,
      ...this.buildFaviconsAndTheme(appName)
    }
  },
  getUrlFromAxiosInstance (axiosInstance, path) {
    return `${axiosInstance.defaults.baseURL}/${path}`
  },
  goToSection (section, duration = 500) {
    Vue.prototype.$scrollTo(`#${section}`, duration, {
      container: 'body',
      easing: 'ease-in',
      lazy: false,
      force: true,
      cancelable: true,
      onStart: function (element) {
        // scrolling started
      },
      onDone: function (element) {
        // scrolling is done
      },
      onCancel () {
        // scrolling has been interrupted
      },
      x: false,
      y: true
    })
  },
  getFirstLevelDomain (domain = null) {
    const domainParts = (domain || window.location.hostname).split('.')
    if (domainParts.length < 2) {
      return domainParts[0]
    }
    return `.${domainParts.slice(domainParts.length - 2, domainParts.length).join('.')}`
  },
  goBack () {
    router.back()
  },
  generateGuid() {
      var S4 = function() {
        return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      };
      return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
  },
  isMobileBrowser () {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  },
  randomUid () {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  },
	inIframe () {
		return window.location !== window.parent.location
	}
}



// WEBPACK FOOTER //
// ./src/helpers/index.js